// hooks/useUser.ts

import { useState, useEffect } from 'react';
import { apiClient } from '../api/client';
import type { User } from '../types';

interface UseUserReturn {
    user: User | null;
    loading: boolean;
    refetch: () => Promise<void>;
}

export const useUser = (): UseUserReturn => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUser();
    }, []);

    const fetchUser = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get('/auth/me/');
            setUser(response.data);
        } catch (error) {
            console.error('Failed to fetch user:', error);
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    return { user, loading, refetch: fetchUser };
};